var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hero-page" }, [
    _c("div", { staticClass: "hero-content" }, [
      _c(
        "div",
        { staticClass: "limited-width-md" },
        [_c("users-auth-register-component")],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "col-md-12 d-flex flex-column align-items-center mb-3",
        domProps: { innerHTML: _vm._s(_vm.translate.login.registrationJoinNow) }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c("h2", { staticClass: "heading-xl text-center mb-4" }, [
          _vm._v(_vm._s(_vm.translate.login.whyRegister))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column justify-content-center" }, [
        _c("div", { staticClass: "limited-width-lg" }, [
          _c("div", { staticClass: "container my-4" }, [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("registration-features-component"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-12 mt-4" },
                  [
                    _c("accordion-component", {
                      attrs: { content: _vm.benefits, prefix: "whyRegister" }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hero-image" })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bc424e02", { render: render, staticRenderFns: staticRenderFns })
  }
}